export const checkCookiesEnabled = (): boolean => {
  try {
    // Пытаемся установить тестовый кук
    document.cookie = 'cookiesTest=1; path=/';
    // Проверяем, установился ли кук
    const cookiesEnabled = document.cookie.includes('cookiesTest=');

    // Удаляем тестовый кук
    document.cookie =
      'cookiesTest=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';

    return cookiesEnabled;
  } catch {
    // Если произошла ошибка, значит куки не поддерживаются
    return false;
  }
};
